import { extend, override } from 'flarum/common/extend';
import ItemList from 'flarum/common/utils/ItemList';
import app from 'flarum/forum/app';

import TagsPage from 'flarum/tags/forum/components/TagsPage';

export default function () {
  override(TagsPage.prototype, 'pageContent', function () {
    const items = new ItemList();

    items.add('hero', this.hero(), 100);
    items.add('main', <div className="sideNavContainer container">{this.mainContent().toArray()}</div>, 10);

    return items;
  });

  override(TagsPage.prototype, 'view', function () {
    return <div className="Osa-TagsPage">{this.pageContent().toArray()}</div>;
  });
}
